import { axiosWithAuth } from "../../helpers";

export const agentSetupService = {
	checkAgentExists,
	updateAgentStatus,
	checkAgentIsPrimary,
	checkIsResidualsStatusConfirmationRequired,
	getLegacyInformation,
	addLegacyInformation,
	updateLegacyInformation,
	deleteLegacyInformation,
	getPaymentInfo,
	getAgentHistory,
	setResidualsStatus,
};

const API_URL = process.env.REACT_APP_API_URL;

const PAGE_SIZE = 50;

function checkAgentExists({ alias, agentId }) {
	const options = {
		url: `${API_URL}/api/agents/check-if-exists`,
		params: { alias, agentId },
	};

	return axiosWithAuth(options);
}

function updateAgentStatus({ id, status }) {
	const options = {
		url: `${API_URL}/api/agents/${id}/update-status`,
		method: "PUT",
		data: { status },
	};
	return axiosWithAuth(options);
}

function checkAgentIsPrimary({ agentId }) {
	const options = {
		url: `${API_URL}/api/agents/${agentId}/check-if-primary-agent`,
	};

	return axiosWithAuth(options);
}

function checkIsResidualsStatusConfirmationRequired({ userId }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/${userId}/deactivate/is_residuals_status_confirmation_required`,
	};

	return axiosWithAuth(options);
}

function getLegacyInformation({ agentId }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/${agentId}/legacy_information`,
	};

	return axiosWithAuth(options);
}

function getPaymentInfo({ agentId }) {
	const options = {
		method: "GET",
		url: `${API_URL}/api/agents/${agentId}/payment_info`,
	};

	return axiosWithAuth(options);
}

function addLegacyInformation({ agentId, data }) {
	const options = {
		method: "POST",
		data,
		url: `${API_URL}/api/agents/${agentId}/legacy_information`,
	};

	return axiosWithAuth(options);
}

function updateLegacyInformation({ agentId, id, data }) {
	const options = {
		method: "PUT",
		data,
		url: `${API_URL}/api/agents/${agentId}/legacy_information/${id}`,
	};

	return axiosWithAuth(options);
}

function deleteLegacyInformation({ agentId, id }) {
	return axiosWithAuth({
		method: "DELETE",
		url: `${API_URL}/api/agents/${agentId}/legacy_information/${id}`,
	});
}

function getAgentHistory({ page, id }) {
	const options = {
		method: "GET",
		params: {
			page_index: page,
			page_size: PAGE_SIZE,
			agentId: id,
		},
		url: `${API_URL}/api/modifications/agents/${id}`,
	};

	return axiosWithAuth(options);
}

function setResidualsStatus(agentId, { residualsStatus, withholdReason }) {
	const options = {
		method: "POST",
		data: {
			status: residualsStatus,
			withhold_reason: withholdReason,
		},
		url: `${API_URL}/api/agents/${agentId}/payment_info/residuals/change_status`,
	};

	return axiosWithAuth(options);
}
